import React from 'react'
import {useState} from 'react'
import './Content.css'
import {Tabs, Tab} from 'react-bootstrap'
import ProductDetail from '../../Pages/Product/Detail'
import PriceFinderDetail from '../../Pages/Pro/PriceFinderDetail'

function Content(props) {
  const [key, setKey] = useState('prices')

  return (
    <Tabs
      activeKey={key}
      onSelect={(k) => setKey(k)}
      id="uncontrolled-tab-example"
      className="tabs mb-3 mt-3 align-items-start justify-content-around">
      <Tab eventKey="prices" title="Precios" className="txt-4--bold-pr">
        <PriceFinderDetail results={props.results} />
      </Tab>
      <Tab
        eventKey="medication-card"
        title="Ficha del Medicamento"
        className="txt-4--bold-pr">
        <ProductDetail
          results={props.results}
          setContactLaboratory={props.setContactLaboratory}
        />
      </Tab>
    </Tabs>
  )
}

export default Content
